import { useState } from "react";
import { Button, Modal, Textarea, TextInput, Flex } from "@mantine/core";
import { useUser } from "@clerk/clerk-react";
import { useSendFeedbackMutation } from "@/features/Feedback/Feedback.api";
import { notifications } from "@mantine/notifications";

export function FeedbackButton() {
  const [opened, setOpened] = useState(false);
  const [text, setText] = useState("");
  const { user } = useUser();
  const [sendFeedback, { isLoading }] = useSendFeedbackMutation();

  const userEmail = user?.primaryEmailAddress?.emailAddress || "";

  const MAX_FEEDBACK_LENGTH = 1000;

  const handleSubmit = async () => {
    if (!text.trim()) {
      notifications.show({
        title: "Error",
        message: "Please enter some feedback text.",
        color: "red",
      });
      return;
    }

    if (text.length > MAX_FEEDBACK_LENGTH) {
      notifications.show({
        title: "Error",
        message: `Feedback text cannot exceed ${MAX_FEEDBACK_LENGTH} characters.`,
        color: "red",
      });
      return;
    }

    try {
      await sendFeedback({ email: userEmail, text }).unwrap();
      notifications.show({
        title: "Success",
        message: "Thank you for your feedback!",
        color: "green",
      });
      setText("");
      setOpened(false);
    } catch (error) {
      notifications.show({
        title: "Error",
        message: "Failed to send feedback. Please try again.",
        color: "red",
      });
    }
  };

  return (
    <>
      <Button variant={"outline"} mb={24} onClick={() => setOpened(true)}>
        Send Feedback
      </Button>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Send Feedback"
        centered
      >
        <Flex direction="column" gap="md">
          <TextInput
            label="Your Email"
            value={userEmail}
            disabled
            variant="filled"
          />
          <Textarea
            label="Feedback"
            placeholder="Type your feedback here..."
            required
            rows={5}
            value={text}
            onChange={(e) => setText(e.currentTarget.value)}
            maxLength={MAX_FEEDBACK_LENGTH}
            description={`${text.length} / ${MAX_FEEDBACK_LENGTH} characters`}
          />
          <Flex gap="sm" justify="flex-end" mt="md">
            <Button variant="subtle" onClick={() => setOpened(false)} disabled={isLoading}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} loading={isLoading}>
              Send
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
}
